import {
    type SlateEditor,
} from '@udecode/plate';

import { BaseFootnotesPlugin } from '../BaseFootnotesPlugin';
import type { TFootnoteElement } from '../types';

export const insertFootnote = (
    editor: SlateEditor
) => {
    const type = editor.getType(BaseFootnotesPlugin);

    editor.tf.withoutNormalizing(() => {
        editor.tf.insertNodes<TFootnoteElement>({
            type,
            index: 0,
            children: [{ text: '' }],
            footnotes: []
        }, {});
    });
};
